// extracted by mini-css-extract-plugin
export var carousel = "partner-carousel-module--carousel--h0LxT";
export var carouselAnimateVertical = "partner-carousel-module--carousel-animate-vertical--YNWsX";
export var carousel__item = "partner-carousel-module--carousel__item--0YrMU";
export var wrapper = "partner-carousel-module--wrapper--75Xi-";